import { Box, HStack, VStack } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../../context/TokenProvider';
import RemoteSubmissionPanelHeader from './RemoteSubmissionPanelHeader';
import RemoteSubmissionNotesPanel from './RemoteSubmissionNotesPanel';
import RemoteSubmissionElementsPanel from './RemoteSubmissionElementsPanel';
import RemoteSubmissionPhotoPanel from './RemoteSubmissionPhotoPanel';
import { useInspectionDetailContext } from '../../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
const RemoteSubmissionPanel = ({ remoteSubmission, handlePopoverOpened, openedIndex, hasMultipleContacts, }) => {
    const tokens = useTokens();
    const { isShare } = useInspectionDetailContext();
    return (React.createElement(Box, { "data-testid": "remote_submission_panel", w: "100%" },
        React.createElement(VStack, { align: "stretch", spacing: tokens.Spacing04 },
            React.createElement(RemoteSubmissionPanelHeader, { handlePopoverOpened: handlePopoverOpened, openedIndex: openedIndex, remoteSubmission: remoteSubmission, hasMultipleContacts: hasMultipleContacts }),
            React.createElement(HStack, { spacing: tokens.Spacing04 },
                React.createElement(RemoteSubmissionPhotoPanel, { isShare: isShare, remoteSubmission: remoteSubmission }),
                React.createElement(Box, { flex: "1" },
                    React.createElement(RemoteSubmissionNotesPanel, { remoteSubmission: remoteSubmission })),
                React.createElement(Box, { flex: "0 0 35%" },
                    React.createElement(RemoteSubmissionElementsPanel, { remoteSubmission: remoteSubmission }))))));
};
export default RemoteSubmissionPanel;
